import Link from '@components/ui-old/link';
import Image from "next/image";
import { ROUTES } from '@utils/routes';
type SearchProductProps = {
  item: any;
};
const SearchProduct: React.FC<SearchProductProps> = ({
  item
}) => {
  const strPrice = item?.strPrice;
  const productSlug = `${item?.id}-${item?.name?.toLowerCase().replace(/\s+/g, '-')}`;
  return <Link href={`${ROUTES.SHOP}/${productSlug}`} className="flex items-center justify-start w-full h-auto group" data-sentry-element="Link" data-sentry-component="SearchProduct" data-sentry-source-file="search-product.tsx">
      <div className="relative flex flex-shrink-0 w-24 h-24 overflow-hidden bg-neutral-200 dark:bg-neutral-800 rounded-md cursor-pointer ltr:mr-4 rtl:ml-4">
        <Image src={item?.photo?.x238 ?? '/assets/placeholder/search-product.svg'} width={96} height={96} loading="eager" alt={item.name || 'Product Image'} className="object-cover bg-neutral-200 dark:bg-neutral-800" style={{
        maxWidth: "100%",
        height: "auto"
      }} data-sentry-element="Image" data-sentry-source-file="search-product.tsx" />
      </div>
      <div className="flex flex-col w-full overflow-hidden">
        <h3 className="mb-2 text-sm truncate text-heading dark:text-neutral-300">{item.name}</h3>
        <div className="text-sm font-semibold text-heading dark:text-neutral-300">
          {strPrice}
        </div>
      </div>
    </Link>;
};
export default SearchProduct;